import { render, staticRenderFns } from "./AddReparingOrder.vue?vue&type=template&id=5bd56ad0&"
import script from "./AddReparingOrder.vue?vue&type=script&lang=js&"
export * from "./AddReparingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports